import React, { createContext, useContext, useEffect, useState } from 'react';
import { applyThemeToDocument, getThemeModeFromDate, getThemeMetaColor } from '../utils/theme';

const ThemeContext = createContext({
  theme: 'dark',
  isLightTheme: false,
  isDarkTheme: true,
  themeColor: '#0d1117',
});

export const ThemeProvider = ({ children }) => {
  const [theme, setTheme] = useState(() => getThemeModeFromDate());

  useEffect(() => {
    applyThemeToDocument(theme);
  }, [theme]);

  useEffect(() => {
    const syncTheme = () => {
      setTheme((currentTheme) => {
        const nextTheme = getThemeModeFromDate();
        return currentTheme === nextTheme ? currentTheme : nextTheme;
      });
    };

    syncTheme();
    const intervalId = window.setInterval(syncTheme, 60 * 1000);
    return () => window.clearInterval(intervalId);
  }, []);

  return (
    <ThemeContext.Provider
      value={{
        theme,
        isLightTheme: theme === 'light',
        isDarkTheme: theme === 'dark',
        themeColor: getThemeMetaColor(theme),
      }}
    >
      {children}
    </ThemeContext.Provider>
  );
};

export const useTheme = () => useContext(ThemeContext);
